<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        Répartition du contrat
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div
      class="card ma-4 pa-4"
    >
      <div class="intro secondary--text">
        Contrat de {{ contrat?.poidsEnTonne }} t
      </div>
      <div class="texte texte-gris-fonce">
        {{ contrat?.typeContrat?.libelle }}
      </div>
      <v-divider class="my-3" />
      <div class="mt-2 intro">
        A quelle culture voulez-vous l'affecter?
      </div>
    
      <v-row
        v-for="culture in contratModifiable.cultures"
        :key="culture.id"
        class="mt-6"
        no-gutters
      >
        <v-col
          cols="7"
          class="intro align-self-center primary--text"
        >
          {{ culture.typeCulture.nom }}
        </v-col>
        <v-col class="align-self-center">
          <AgrialInputNumber
            v-model="culture.poidsEnTonne"
            :rules="[rules.required]"
            label="Répartition"
            suffix="t"
            hide-details
          />
        </v-col>
      </v-row>
    </div>
    <BaseMessage
      v-if="erreur"
      class="mb-4 mx-5"
      color="error"
      :message="erreur"
      text
      type="error"
    />
    <BaseMessage
      v-if="hasErreurCalculRepartition"
      class="mb-4 mx-5"
      color="error"
      message="Répartition des tonnages invalide"
      text
      type="error"
    />
    <div class="d-flex justify-space-around">
      <AgrButton
        class="pa-5"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="!isValid"
        :loading="loading"
        class="pa-5"
        @click="saveRepartition()"
      >
        Valider
      </AgrButton>
    </div>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import { mapActions } from 'vuex'
import BaseMessage from '@/components/common/base-message.vue'
import { clone } from '@/utils/clone'
import { equalDecimals } from'@/utils/math'
import { sum } from 'lodash'

export default {
  name: 'RepartitionContratAdherentModal',
  components: {AgrButton, AgrialInputNumber, BaseMessage},
  props: {
    contrat: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      loading: false,
      erreur: null,
      contratModifiable: {cultures: []},
      rules: {
        required: value => (value !== null && value !== '') || 'Champ requis'
      }
    }
  },

  computed: {
    isValid () {
      return this.contratModifiable!= null && this.contratModifiable.cultures!= null ? this.contratModifiable.cultures.filter(c => c.poidsEnTonne === null).length === 0 && !this.hasErreurCalculRepartition : true
    },
    hasErreurCalculRepartition () {
      return this.contratModifiable != null && this.contratModifiable.cultures != null && this.contratModifiable.cultures.length ?
        !equalDecimals(sum(this.contratModifiable.cultures.map(c => c.poidsEnTonne)), this.contrat.poidsEnTonne) : false
    }
  },
  watch: {
    contrat: {
      handler () {
        this.contratModifiable = this.contrat!= null ? clone(this.contrat) : {}
      },
      immediate: true
    }
  },

  methods: {
    ...mapActions({
      createOrUpdateContratVente: 'contratVente/createOrUpdateContratVente'
    }),
    saveRepartition () {
      this.loading = true
      this.erreur = null
      this.createOrUpdateContratVente(this.contratModifiable)
        .catch(err => {
          this.erreur = err.response.data.message
        })
        .finally(() => {
          this.$emit('reload')
          this.onClose()
          this.loading = false
        })
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.card {
  border: 1px solid #d7d8d6;
  border-radius: 4px;
}
</style>
